import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { format, parseISO } from 'date-fns';

interface Props {
  onChange: (dateRange: { start_date?: string; end_date?: string }) => void;
  /** Période imposée de l'extérieur (navigation par mois, réinitialisation).
   *  Omise, le filtre reste autonome — c'est le comportement historique. */
  value?: { start_date?: string; end_date?: string };
}

export default function DateRangeFilter({ onChange, value }: Props) {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  // Quand la période est pilotée ailleurs, les champs doivent suivre : sinon ils
  // affichent encore l'ancienne sélection et l'utilisateur ne sait plus ce qu'il lit.
  useEffect(() => {
    if (!value) return;
    setStartDate(value.start_date ? parseISO(value.start_date) : null);
    setEndDate(value.end_date ? parseISO(value.end_date) : null);
  }, [value?.start_date, value?.end_date]);

  const handleDateChange = (start: Date | null, end: Date | null) => {
    setStartDate(start);
    setEndDate(end);
    
    const dateRange = {
      start_date: start ? format(start, 'yyyy-MM-dd') : undefined,
      end_date: end ? format(end, 'yyyy-MM-dd') : undefined,
    };
    
    onChange(dateRange);
  };

  return (
    <div className="flex space-x-4">
      <div>
        <label className="block text-sm font-medium text-gray-700">Date de début</label>
        <DatePicker
          selected={startDate}
          onChange={(date) => handleDateChange(date, endDate)}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          dateFormat="dd/MM/yyyy"
          className="w-full px-3 py-2 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500 text-gray-900"
          placeholderText="Sélectionner..."
          portalId="datepicker-portal"
          popperProps={{ strategy: 'fixed' }}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700">Date de fin</label>
        <DatePicker
          selected={endDate}
          onChange={(date) => handleDateChange(startDate, date)}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={startDate}
          dateFormat="dd/MM/yyyy"
          className="w-full px-3 py-2 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500 text-gray-900"
          placeholderText="Sélectionner..."
          portalId="datepicker-portal"
          popperProps={{ strategy: 'fixed' }}
        />
      </div>
    </div>
  );
}